import React, { useContext, useEffect, useRef, useState } from 'react'
import { Col, Row } from 'reactstrap'
import { store } from '../../stores/pages'

export default function PageActions() {
  const { title, html, formRef, admin, dispatch, actions } = useContext(store)
  const [scrollTop, setScrollTop] = useState(0)
  const scrollTopRef = useRef(0)
  const iframeRef = useRef(null)

  useEffect(() => {
    if (formRef) {
      dispatch({ type: actions.UPDATE_HTML })
    }
  }, [formRef])

  useEffect(() => {
    scrollTopRef.current = scrollTop
  }, [scrollTop])

  useEffect(() => {
    if (iframeRef.current) {
      dispatch({ type: actions.SET_IFRAME_REF, payload: iframeRef.current })
      iframeRef.current.onload = () => {
        iframeRef.current.contentWindow.scrollTo(0, scrollTopRef.current, { behavior: 'instant' })
        iframeRef.current.contentWindow.addEventListener('scroll', () => {
          setScrollTop(iframeRef.current.contentWindow.scrollY)
        })
      }
    }
  }, [iframeRef.current])

  useEffect(() => {
    const handleUploadSelected = (event) => {
      const { image, id } = event.detail
      if (iframeRef.current) {
        iframeRef.current.contentWindow.postMessage({ type: "uploadSelected", id, image })
      }
    }

    const handleGallerySelected = (event) => {
      const { images, id } = event.detail
      if (iframeRef.current) {
        iframeRef.current.contentWindow.postMessage({ type: "gallerySelected", id, images })
      }
    }

    document.addEventListener("uploadSelected", handleUploadSelected)
    document.addEventListener("gallerySelected", handleGallerySelected)
    return () => {
      document.removeEventListener("uploadSelected", handleUploadSelected)
      document.removeEventListener("gallerySelected", handleGallerySelected)
    }
  }, [])

  return (
    <div className="producer-previews">
      <div className={`producer-page-browser ${admin?.devMode && 'mb-0'}`}>
        <Row className="producer-page-browser-header align-items-center">
          <Col xs="auto">
            <div className="producer-page-browser-button"></div>
            <div className="producer-page-browser-button"></div>
            <div className="producer-page-browser-button"></div>
          </Col>
          <Col className="text-center">
            <div className="producer-page-browser-url overflow-ellipsis">{title || 'Page Preview'}</div>
          </Col>
        </Row>
        <div className="producer-page-browser-content">
          <iframe className="producer-page-browser-iframe" ref={iframeRef} srcDoc={html}></iframe>
        </div>
      </div>
    </div>
  )
}
